export default __webpack_public_path__ + "static/media/c1.deb65a84.png";